import { contactService } from '../../../services/service-factory';

export default {
  data: function() {
    return {
      contactService: undefined
    };
  },
  created: function() {
    this.contactService = contactService;
  }
};
